import { render, staticRenderFns } from "./CreateTradeContractFormatForm.vue?vue&type=template&id=44b38f96&"
import script from "./CreateTradeContractFormatForm.vue?vue&type=script&lang=ts&"
export * from "./CreateTradeContractFormatForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports